import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import type { Assessment } from 'modules/competencies/store/models/Assessment'

interface Props {
  assessment: Assessment
  onClose: () => void
}

const Comment = ({ assessment, onClose }: Props) => {
  return (
    <Modal
      title={i18n.t('competencies_v2.assessments.comment.title', {
        competency_name: assessment.competency.attributes.name,
      })}
      onClose={onClose}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.cancel')}
        </Button>
      }
    >
      <TextArea
        placeholder={i18n.t('competencies_v2.assessments.comment.placeholder')}
        value={assessment?.attributes.description}
        readonly
      />
    </Modal>
  )
}

export default observer(Comment)
